import React, { useState } from "react";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { api, vibrate } from "@/lib/api";

export default function MagicLink() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const em = email.trim().toLowerCase();
    if (!em || !em.includes("@")) { setError("Entre une adresse email valide."); return; }
    setLoading(true); setError(""); vibrate();
    try {
      await api.post("/auth/magic/request", { email: em });
      setSent(true);
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Une erreur est survenue. Réessaie.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div data-testid="magic-sent" className="rounded-2xl bg-emerald-500/10 border border-emerald-500/25 p-4 text-center">
        <CheckCircle2 className="mx-auto text-emerald-400 mb-2" size={22} />
        <p className="text-sm font-semibold text-emerald-200">Lien envoyé 📬</p>
        <p className="text-xs text-zinc-400 mt-1">
          On vient d'envoyer un lien de connexion à <span className="text-zinc-200 font-medium">{email.trim().toLowerCase()}</span>.
          Ouvre-le pour te connecter (valable 20 min).
        </p>
        <button
          data-testid="magic-resend"
          onClick={() => { setSent(false); }}
          className="mt-3 text-xs text-pink-400 font-semibold hover:text-pink-300"
        >
          Utiliser une autre adresse
        </button>
      </div>
    );
  }

  if (!open) {
    return (
      <button
        data-testid="magic-open"
        onClick={() => { vibrate(); setOpen(true); }}
        className="w-full flex items-center justify-center gap-2 rounded-full bg-zinc-900 border border-zinc-700 text-zinc-200 font-bold py-4 px-6 active:scale-95 transition-transform hover:border-pink-500/40"
      >
        <Mail size={18} /> Continuer par email
      </button>
    );
  }

  return (
    <form onSubmit={submit} data-testid="magic-form" className="space-y-2">
      <div className="flex items-center gap-2 rounded-full bg-zinc-900 border border-zinc-700 px-4 focus-within:border-pink-500/50">
        <Mail size={16} className="text-zinc-500 shrink-0" />
        <input
          data-testid="magic-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="ton@email.com"
          autoFocus
          className="flex-1 bg-transparent py-3.5 text-sm outline-none text-zinc-100"
        />
      </div>
      {error && <p data-testid="magic-error" className="text-xs text-red-400 px-2">{error}</p>}
      <button
        data-testid="magic-submit"
        disabled={loading}
        className="w-full flex items-center justify-center gap-2 rounded-full bg-pink-500 text-white font-bold py-3.5 active:scale-95 transition-transform hover:bg-pink-600 disabled:opacity-60"
      >
        {loading ? <Loader2 size={18} className="animate-spin" /> : "Recevoir mon lien de connexion"}
      </button>
    </form>
  );
}
